// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_withdrawRentalProperty(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["RentalPropertyWithdrawn"]);
}

let variablesConverter = {"withdrawRentalPropertyInput":{},"__root":{"input":{"r":"withdrawRentalPropertyInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"withdrawRentalProperty_RentalPropertyWithdrawn_property":{"f":""},"withdrawRentalProperty":{"u":"response_withdrawRentalProperty"}}};

let wrapResponseConverterMap = {
  response_withdrawRentalProperty: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"withdrawRentalProperty_RentalPropertyWithdrawn_property":{"f":""},"withdrawRentalProperty":{"u":"response_withdrawRentalProperty"}}};

let responseConverterMap = {
  response_withdrawRentalProperty: unwrap_response_withdrawRentalProperty
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusChangeComment",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WithdrawRentalPropertyDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "withdrawRentalProperty",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RentalPropertyV5",
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LandlordPropertyStatusCallout_rentalPropertyV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ClientPageMatchingStatusLabel_matchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "RentalPropertyWithdrawn",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WithdrawRentalPropertyDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "withdrawRentalProperty",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RentalPropertyV5",
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isRenewable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activeUntil",
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveProperty",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expiredAt",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "type": "ExpiredProperty",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "withdrawnAt",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ],
                        "type": "WithdrawnProperty",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusChangedAt",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ],
                        "type": "RentedProperty",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activelyMatching",
                        "storageKey": null
                      }
                    ],
                    "type": "Matchable",
                    "abstractKey": "__isMatchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "RentalPropertyWithdrawn",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c3dcf42341d0b7213af6dc2a6ed5b0af",
    "id": null,
    "metadata": {},
    "name": "WithdrawRentalPropertyDialogMutation",
    "operationKind": "mutation",
    "text": "mutation WithdrawRentalPropertyDialogMutation(\n  $input: WithdrawRentalPropertyInput!\n) {\n  withdrawRentalProperty(input: $input) {\n    __typename\n    ... on RentalPropertyWithdrawn {\n      property {\n        ...LandlordPropertyStatusCallout_rentalPropertyV5\n        ...ClientPageMatchingStatusLabel_matchable\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ClientPageMatchingStatusLabel_matchable on Matchable {\n  __isMatchable: __typename\n  __typename\n  activelyMatching\n}\n\nfragment ExpiredRentalPropertyCallout_expiredProperty on ExpiredProperty {\n  expiredAt\n  archived\n}\n\nfragment ExpiringRentalPropertyCallout_activeProperty on ActiveProperty {\n  activeUntil\n}\n\nfragment LandlordPropertyStatusCallout_rentalPropertyV5 on RentalPropertyV5 {\n  id\n  nodeId\n  status {\n    __typename\n    ... on ActiveProperty {\n      isRenewable\n      ...ExpiringRentalPropertyCallout_activeProperty\n    }\n    ... on ExpiredProperty {\n      ...ExpiredRentalPropertyCallout_expiredProperty\n    }\n    ... on WithdrawnProperty {\n      ...WithdrawnPropertyCallout_withdrawnProperty\n    }\n    ... on RentedProperty {\n      ...RentedPropertyCallout_rentedProperty\n    }\n  }\n}\n\nfragment RentedPropertyCallout_rentedProperty on RentedProperty {\n  statusChangedAt\n  statusChangeComment\n  archived\n}\n\nfragment WithdrawnPropertyCallout_withdrawnProperty on WithdrawnProperty {\n  withdrawnAt\n  statusChangeComment\n  archived\n}\n"
  }
};
})());

let wrap_response_withdrawRentalProperty = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_withdrawRentalProperty = unwrap_response_withdrawRentalProperty;
exports.wrap_response_withdrawRentalProperty = wrap_response_withdrawRentalProperty;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
